/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import ModelDialogButton from "./dialog-button";
import { useTheme } from "@mui/material/styles";

const AddModelButton = (props) => {
    
    const theme = useTheme();
    const setOpen = props.setOpen;

    
    return (
        <Fragment>
            <ModelDialogButton
                setOpen={setOpen}
                color={theme.palette.primary.main}
            />
        </Fragment>
    );
};

export default AddModelButton;
